/**
 * Ποιοι αριθμοί σελίδων εμφανίζονται, όταν δεν χωρούν όλοι.
 *
 * Πάντα η πρώτη, η τελευταία και η γειτονιά της τρέχουσας· τα κενά γίνονται
 * αποσιωπητικά. Το `'…'` δεν είναι κουμπί: είναι ένδειξη ότι υπάρχει συνέχεια.
 *
 * Καθαρή συνάρτηση σε δικό της αρχείο, ώστε να δοκιμάζεται χωρίς απόδοση
 * React. Τα όρια είναι το εύκολο σημείο να σπάσει κάτι — μία σελίδα, δύο
 * σελίδες, τρέχουσα στην αρχή ή στο τέλος — και κανένα από αυτά δεν φαίνεται
 * ως σφάλμα: φαίνεται ως σελιδοποίηση που απλώς δείχνει λάθος αριθμούς.
 */
export function pageWindow(current, total, { span = 1 } = {}) {
    if (!Number.isInteger(total) || total < 1) return [];
    if (total <= 5 + span * 2) return Array.from({ length: total }, (_, index) => index + 1);

    const page = Math.min(Math.max(1, current), total);
    const pages = new Set([1, total]);

    for (let offset = -span; offset <= span; offset += 1) {
        const candidate = page + offset;
        if (candidate >= 1 && candidate <= total) pages.add(candidate);
    }

    // Στα άκρα η γειτονιά «ξοδεύεται» έξω από το εύρος και η μπάρα κονταίνει
    // απότομα. Συμπληρώνεται από την άλλη πλευρά, ώστε το πλάτος να μένει
    // σταθερό και τα κουμπιά να μη χοροπηδούν κάτω από τον δείκτη.
    if (page <= 2 + span) for (let n = 1; n <= 3 + span; n += 1) pages.add(n);
    if (page >= total - 1 - span) for (let n = total - 2 - span; n <= total; n += 1) pages.add(n);

    const sorted = [...pages].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
    const output = [];

    for (const [index, value] of sorted.entries()) {
        if (index > 0 && value - sorted[index - 1] > 1) output.push('…');
        output.push(value);
    }

    return output;
}

export default pageWindow;
